<template>
  <div class="flex h-screen overflow-hidden" style="background-image: url('https://images.unsplash.com/photo-1519147540699-2c85a1d4ba74?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=d2f57325b8e9bd293be537c3b62443c1&auto=format&fit=crop&w=2250&q=80" id="app">
    <div class="w-1/4 overflow-hidden bg-white-90 mt-8 mb-8 ml-8 rounded-l-lg shadow-md">
      <img class="h-full opacity-75" style="object-fit: cover" src="https://images.unsplash.com/photo-1523318500297-5de0dbf1dbd9?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=5f230d628d69e1512fb93d6199cd11b2&auto=format&fit=crop&w=934&q=80" v-if="!this.isNavigationActive" />
      <Menu v-if="this.isNavigationActive"/>
    </div>

    <div class="w-4/5 overflow-y-auto mt-8 mb-8 mr-8 py-16 px-16 rounded-r-lg bg-white shadow">
      <router-view/>
    </div>
  </div>
</template>

<script>
import "./assets/css/main.css";
import Menu from "./components/Menu";
import NewAlbum from "./components/NewAlbum";
import AuthController from "./controllers/AuthController";

export default {
  components: {
    Menu,
    NewAlbum,
    AuthController
  },
  name: "App",
  data() {
    return {
      isNavigationActive: false,
    };
  },

  created() {
    AuthController.isLoggedIn(result => {
      this.isNavigationActive = result != null;
      if(!this.isNavigationActive) {
        this.$router.push("welcome")
      }
    });

    // Listen for events
    this.$root.$on("onCreateNewAlbum", () => {
      this.$router.push("/album/new");
    });

    this.$root.$on("onCreateAlbumCanceled", () => {
      this.$router.push("gallery");
    });

    this.$root.$on("onAlbumSelected", albumId => {
      this.$router.push("/album/" + albumId);
    });

    // Main Navigation
    this.$root.$on("onNavigateToGallery", () => {
      this.$router.push("/gallery");
    });

    this.$root.$on("onNavigateToClients", () => {
      this.$router.push("gallery");
    });

    this.$root.$on("onNavigateToStats", () => {
      this.$router.push("gallery");
    });

    this.$root.$on("onNavigateToSettings", () => {
      AuthController.logout()
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/App.vue